var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexDetail1"},[_c('section',{staticClass:"banner inner-banner"},[_c('img',{attrs:{"src":_vm.list.bannerImg}})]),_c('div',{staticClass:"content-edit",domProps:{"innerHTML":_vm._s(_vm.wcwkDetail)}})])}
var staticRenderFns = []

export { render, staticRenderFns }